import React from "react";
import classNames from "classnames";
import { compose } from "redux";

import withTranslations from "../../../../../hocs/withTranslations";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";
import NewModal from "../../NewModal";

const ConfirmModal = ({
  title,
  message,
  hideModal,
  translate,
  decisionLabels = {},
  confirm,
  cancel,
  secondaryConfirm
}) => {
  const isDesktop = useIsDesktop();
  const hasSecondaryConfirm = typeof secondaryConfirm === "function";

  const messageContent =
    typeof message === "string" ? translate(message) : message;

  const resolveDecision = decision => {
    decision?.();
    hideModal?.();
  };

  const actionButtons = hasSecondaryConfirm ? (
    <div
      className={classNames("flex gap-4", {
        "justify-end": isDesktop,
        "flex-col": !isDesktop
      })}
    >
      {typeof confirm === "function" ? (
        <button
          type="button"
          className="button-1"
          onClick={() => resolveDecision(confirm)}
        >
          {translate(decisionLabels.confirm || "Confirm")}
        </button>
      ) : null}
      <button
        type="button"
        className="button-1"
        onClick={() => resolveDecision(secondaryConfirm)}
      >
        {translate(decisionLabels.secondaryConfirm || "Secondary confirm")}
      </button>
    </div>
  ) : null;

  return (
    <NewModal
      hideModal={hideModal}
      title={typeof title === "string" ? translate(title) : title}
      cancelButtonText={
        typeof cancel === "function"
          ? translate(decisionLabels.cancel || "Cancel")
          : null
      }
      acceptButtonText={
        !hasSecondaryConfirm && typeof confirm === "function"
          ? translate(decisionLabels.confirm || "Confirm")
          : null
      }
      onCancel={cancel}
      onAccept={confirm}
      onClose={cancel}
      acceptButton={actionButtons}
    >
      {messageContent ? (
        <p className="text-sm text-black opacity-70 mb-6">{messageContent}</p>
      ) : null}
    </NewModal>
  );
};

export default compose(withTranslations)(ConfirmModal);
